module.exports = __webpack_public_path__ + "static/media/peds-icons-3@3x.7dfbbdc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peds-icons-3@3x.png
// module id = 1740
// module chunks = 0